import { render, staticRenderFns } from "./BtnFloating.vue?vue&type=template&id=76a8cdd1"
import script from "./BtnFloating.vue?vue&type=script&lang=js"
export * from "./BtnFloating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports